<h2>Company Data Mapping</h2>

<div class="px-2 py-3 contents h-full max-h-80" *ngIf="isLoadCompanyMappingGridDataSource">
    <div class="flex pb-4 justify-start">
        <dx-check-box [value]="false" text="Include deactivated Company Mapping Items" class="pr-2" (onValueChanged)="extraFilteringOptionsChange('Active', $event)"></dx-check-box>
    </div>
    <div class="mapping-grid-container shadow-lg">
        <dx-data-grid
            #companyMappingDataGrid
            id="companyMappingDataGrid"
            [allowColumnResizing]="true"
            [columnResizingMode]="'widget'"
            [allowColumnReordering]="true"
            [dataSource]="companyMappingDataSource"
            [showBorders]="true"
            [columnAutoWidth]="true"
            [remoteOperations]="true"
            [hoverStateEnabled]="true"
            [(selectedRowKeys)]="companyMappingSelectedRowMap"
            (onSelectionChanged)="selectionMappingDataChangedHandler()"
            (onContentReady)="onReady($event)"
            (onContextMenuPreparing)="companyMappingDataGridContextMenu($event)"
            keyExpr="CompanyMappingId"
            >
            <dxo-state-storing
                    [enabled]="true"
                    type="custom"
                    [customLoad]="loadMappingState"
                    [customSave]="saveMappingState">
            </dxo-state-storing>
            <dxo-load-panel
                [enabled]="false"
                shadingColor="rgba(0,0,0,0.4)"
                [showIndicator]="true"
                [showPane]="true"
                [shading]="true">
            </dxo-load-panel>
            <dxo-filter-panel [visible]="true"></dxo-filter-panel>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-pager
                [visible]="true"
                [allowedPageSizes]="[5, 10, 25, 50, 100]"
                displayMode="compact"
                [showPageSizeSelector]="true"
                [showNavigationButtons]="false"
            >
            </dxo-pager>
            <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>
            <dxo-selection mode="single"></dxo-selection>
            <dxo-column-chooser [enabled]="true" mode="dragAndDrop"></dxo-column-chooser>

            <dxi-column dataField="CompanyMappingId" [allowHeaderFiltering]="false" [width]="140" caption="Company Mapping" [customizeText]="customizeCompanyMappingId"></dxi-column>
            <dxi-column caption="Action" cellTemplate="action" alignment="center" [allowHeaderFiltering]="false"></dxi-column>
            <dxi-column caption="Source Data">
                <dxi-column dataField="DataProviderCode" caption="Data Provider Code">
                    <dxo-header-filter [dataSource]="dataProviderCodeHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="SourceCompany" caption="Company">
                    <dxo-header-filter [dataSource]="companyNamedHeaderDataSource"></dxo-header-filter>
                </dxi-column>
            </dxi-column>

            <dxi-column dataField="MappingModeName" caption="Mapping Mode">
                <dxo-header-filter [dataSource]="mappingModeHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column caption="Mapping Counts">
                <dxi-column dataField="TotalCount">
                    <dxo-header-filter [dataSource]="totalCountHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="NewCount" caption="New">
                    <dxo-header-filter [dataSource]="newHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="MapCount" caption="Map">
                    <dxo-header-filter [dataSource]="mapHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="SaveCount" caption="Save">
                    <dxo-header-filter [dataSource]="saveHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="OmitCount" caption="Omit">
                    <dxo-header-filter [dataSource]="omitHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="IsInconsistentMappingMessage" caption="Inconsistency">
                    <dxo-header-filter [dataSource]="inconsistencyHeaderDataSource"></dxo-header-filter>
                </dxi-column>
            </dxi-column>
            <dxi-column caption="Mapped to">
                <dxi-column dataField="ProductBrandingLevelId" caption="Branding Level Id">
                    <dxo-header-filter [dataSource]="productBrandingLevelIdHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ProductBrandingLevelName" caption="Branding Level">
                    <dxo-header-filter [dataSource]="productBrandingLevelNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ProductMasterEntityId" caption="Entity Id">
                    <dxo-header-filter [dataSource]="productMasterEntityIdNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="CompanyName" caption="Company">
                    <dxo-header-filter [dataSource]="companyNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="MasterBrandName" caption="Master Brand">
                    <dxo-header-filter [dataSource]="masterBrandNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="BrandName" caption="Brand">
                    <dxo-header-filter [dataSource]="brandNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="SubBrandName" caption="Sub-brand">
                    <dxo-header-filter [dataSource]="subBrandNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
            </dxi-column>
            <dxi-column caption="Data auditing">
                <dxi-column dataField="CreatedByUserFullNameSortableOrPrincipalName" caption="Created by" [visible]="false">
                    <dxo-header-filter [dataSource]="createdByHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="CreatedOn" caption="Create on" dataType="date" format="M/d/yyyy, HH:mm" dataType="datetime" [visible]="false" cssClass="hide-filter-icon">
                    <dxo-header-filter [dataSource]="createdOnHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ModifiedByUserFullNameSortableOrPrincipalName" caption="Modified by" >
                    <dxo-header-filter [dataSource]="modifiedByHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ModifiedOn" caption="Modified on" dataType="date" format="M/d/yyyy, HH:mm" dataType="datetime" [visible]="false" cssClass="hide-filter-icon">
                    <dxo-header-filter [dataSource]="modifiedOnHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ReviewedByUserFullNameSortableOrPrincipalName" caption="Reviewed by" [visible]="false">
                    <dxo-header-filter [dataSource]="reviewedByHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ReviewedOn" caption="Reviewed on" dataType="date" format="M/d/yyyy, HH:mm" dataType="datetime" [visible]="false" cssClass="hide-filter-icon">
                    <dxo-header-filter [dataSource]="reviewedOnHeaderDataSource"></dxo-header-filter>
                </dxi-column>
            </dxi-column>

            <div *dxTemplate="let action of 'action'">
                <dx-button class="mr-1" icon="fas fa-ban fa-1x" hint="Omit" [disabled]="action?.data?.MappingModeId == 3" (onClick)="omit(action?.data?.CompanyMappingId)"></dx-button>
                <dx-button class="mr-1" icon="far fa-bookmark fa-1x" hint="Save" [disabled]="action?.data?.MappingModeId == 2" (onClick)="save(action?.data?.CompanyMappingId)"></dx-button>
<!--                <dx-button-->
<!--                    id="btnAccept"-->
<!--                    *ngIf="action?.data?.ModifiedByUserId <= 0 && action?.data?.MappingModeId == 0"-->
<!--                    class="mr-1"-->
<!--                    icon="fa fa-check fa-1x"-->
<!--                    hint="Accept"-->
<!--                    (onClick)="accept(action?.data?.CompanyMappingId)"-->
<!--                ></dx-button>-->
                <dx-button
                    id="btnReview"
                    *ngIf="action?.data?.ModifiedByUserId > 0 && action?.data?.ModifiedByUserId != currentUser?.UserId && action?.data?.ReviewedByUserId == -1"
                    class="mr-1"
                    icon="fas fa-check-double fa-1x"
                    hint="Review"
                    (onClick)="review(action?.data?.CompanyMappingId)"
                ></dx-button>
                <dx-button *ngIf="currentUser?.UserRoleId > 1 && action?.data?.Active" icon="fas fa-trash-alt fa-1x" hint="Deactivate" (onClick)="deactivate(action?.data?.CompanyMappingId)"></dx-button>
                <dx-button *ngIf="currentUser?.UserRoleId > 1 && !action?.data?.Active" icon="fas fa-trash-alt fa-1x" hint="Reactivate" (onClick)="reactivate(action?.data?.CompanyMappingId)"></dx-button>
            </div>
            <dxo-paging [pageSize]="5"></dxo-paging>
        </dx-data-grid>
    </div>
</div>

<div class="py-3 block h-full" *ngIf="isLoadCompanyMasterGridDataSource">
    <div class="mapping-grid-container shadow-lg">
        <dx-data-grid
            #companyMasterDataGrid
            id="companyMasterDataGrid"
            [allowColumnResizing]="true"
            [columnResizingMode]="'widget'"
            [allowColumnReordering]="true"
            [dataSource]="companyMasterDataSource"
            [showBorders]="true"
            [columnAutoWidth]="true"
            [remoteOperations]="true"
            [hoverStateEnabled]="true"
            [(selectedRowKeys)]="companyMasterSelectedRowMap"
            (onContentReady)="onReadyMasterGrid($event)"
            (onSelectionChanged)="selectionMasterDataChangedHandler()"
            (onContextMenuPreparing)="companyMasterDataGridContextMenu($event)"
            keyExpr="RowId"
        >
            <dxo-state-storing
                    [enabled]="true"
                    type="custom"
                    [customLoad]="loadMasterState"
                    [customSave]="saveMasterState">
            </dxo-state-storing>
            <dxo-load-panel
                [enabled]="false"
                shadingColor="rgba(0,0,0,0.4)"
                [showIndicator]="true"
                [showPane]="true"
                [shading]="true">
            </dxo-load-panel>
            <dxo-filter-panel [visible]="true"></dxo-filter-panel>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-pager
                [visible]="true"
                displayMode="compact"
                [allowedPageSizes]="[5, 10, 25, 50, 100]"
                [showPageSizeSelector]="true"
                [showNavigationButtons]="false"
            >
            </dxo-pager>
            <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>
            <dxo-selection mode="single"></dxo-selection>
            <dxo-search-panel [visible]="true" [(text)]="searchText"></dxo-search-panel>
            <dxo-column-chooser [enabled]="true" mode="dragAndDrop"></dxo-column-chooser>

            <dxi-column dataField="RowId" [allowHeaderFiltering]="false" [width]="140" caption="Branding Roster Id" [customizeText]="customizeCompanyMasterId"></dxi-column>
            <dxi-column caption="Action" [allowHeaderFiltering]="false" [width]="90" cellTemplate="action" alignment="center"></dxi-column>
            <dxi-column dataField="ProductBrandingLevelName" caption="Branding Level">
                <dxo-header-filter [dataSource]="brandingLevelHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CompanyName" caption="Company">
                <dxo-header-filter [dataSource]="sourceCompanyHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="MasterBrandName" caption="Master Brand">
                <dxo-header-filter [dataSource]="masterTableMasterBrandNameHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="BrandName" caption="Brand">
                <dxo-header-filter [dataSource]="masterTableBrandNameHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="SubBrandName" caption="Sub-brand">
                <dxo-header-filter [dataSource]="masterTableSubBrandNameHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CompanyId" [allowHeaderFiltering]="false" [allowFiltering]="false" [visible]="false">
            </dxi-column>
            <dxi-column dataField="MasterBrandRelationId" [allowHeaderFiltering]="false" [allowFiltering]="false" [visible]="false">
            </dxi-column>
            <dxi-column dataField="BrandRelationId" [allowHeaderFiltering]="false" [allowFiltering]="false" [visible]="false">
            </dxi-column>
            <dxi-column dataField="SubBrandRelationId" [allowHeaderFiltering]="false" [allowFiltering]="false" [visible]="false">
            </dxi-column>
            <div *dxTemplate="let action of 'action'">
                <dx-button
                        class="mr-1"
                        icon="fas fa-map-marker-alt fa-1x"
                        hint="Map"
                        (onClick)="map(action?.data?.CompanyId, action?.data?.ProductBrandingLevelId, action?.data?.ProductMasterEntityId)"
                ></dx-button>
                <dx-button
                        *ngIf="currentUser?.UserRoleId > 1 && action?.data?.ProductBrandingLevelId === 0"
                        icon="fas fa-trash-alt fa-1x"
                        hint="Deactivate"
                        (onClick)="deactivateCompanyMaster(action?.data?.CompanyId, action?.data?.ProductBrandingLevelId)">
                </dx-button>
                <dx-button
                        *ngIf="currentUser?.UserRoleId > 1 && action?.data?.ProductBrandingLevelId === 1 && action?.data?.MasterBrandRelationId > 0"
                        icon="fas fa-trash-alt fa-1x"
                        hint="Deactivate"
                        (onClick)="deactivateCompanyMaster(action?.data?.MasterBrandRelationId, action?.data?.ProductBrandingLevelId)">
                </dx-button>
                <dx-button
                        *ngIf="currentUser?.UserRoleId > 1 && action?.data?.ProductBrandingLevelId === 2 && action?.data?.BrandRelationId > 0"
                        icon="fas fa-trash-alt fa-1x"
                        hint="Deactivate"
                        (onClick)="deactivateCompanyMaster(action?.data?.BrandRelationId, action?.data?.ProductBrandingLevelId)">
                </dx-button>
                <dx-button
                        *ngIf="currentUser?.UserRoleId > 1 && action?.data?.ProductBrandingLevelId === 3 && action?.data?.SubBrandRelationId > 0"
                        icon="fas fa-trash-alt fa-1x"
                        hint="Deactivate"
                        (onClick)="deactivateCompanyMaster(action?.data?.SubBrandRelationId, action?.data?.ProductBrandingLevelId)">
                </dx-button>
            </div>
            <dxo-paging [pageSize]="5"></dxo-paging>
        </dx-data-grid>
    </div>
</div>
